import { datadogRum } from '@datadog/browser-rum';
/* global ire */
import isQABot from './isQABot';
import isMocked from './isMocked';

export const submitConversionToImpact = (userUid, organizationUid) => {
  if (process.env.NODE_ENV !== 'production' || isQABot() || isMocked()) return;
  try {
    ire(
      'trackConversion',
      23523,
      { orderId: userUid, customerId: organizationUid },
      { verifySiteDefinitionMatch: true }
    );
  } catch (error) {
    console.log(`Error sending data to impact. Error: ${error}`);
    datadogRum.addError(new Error(error));
  }
};

export const submitConversionToRokt = ({
  email,
  conversionType = 'free-trial-signup',
  firstName,
  lastName,
  plan,
  userUid,
} = {}) => {
  if (/@podium.com\s*$/.test(email)) {
    return;
  }

  console.debug('Attempting to send the submission to Rokt');
  try {
    window.rokt &&
      window.rokt.onLoaded((rokt) => {
        rokt.setAttributes({
          email: email,
          firstname: firstName,
          lastname: lastName,
          conversiontype: conversionType,
          productname: plan,
          confirmationref: userUid,
          quantity: 1,
        });

        // Necessary for Rokt to observe a conversion
        rokt.triggerPageChange({
          pageIdentifier: 'confirmation.page',
        });

        // Performs Rokt Cleanup
        rokt.closeAll();
      });
  } catch (err) {
    console.log('Sending to Rokt failed.', err);
    datadogRum.addError(new Error(err));
  }
};
